import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getServerTime } from '../../../util/responseUtil';
import { ROLE_CATEGORY_CONSTANT } from '../../../constants/roleCategoryConstant';
import ActionType from '../../../redux/reducer/globalActionType';
import API_TICKET_LIST from '../../../api/apiTicketList';
import API_SEARCH from '../../../api/apiSearch';
import HideButton from '../../../components/Common/HideButton';
import PreviousPageButton from '../../../components/Common/PreviousPageButton';
import NextPageButton from '../../../components/Common/NextPageButton';
import ShowCountTicket from '../../../components/Common/ShowCountTicket';
import TicketChannel from '../../../components/TicketList/TicketChannel';
import TicketSort from '../../../components/Common/TicketSort';
import TicketPage from '../../../components/Common/TicketPage';
import TicketCard from '../../../components/TicketList/TicketCard';
import TicketPhoneSideOutside from '../../../components/TicketList/TicketPhoneSideOutside';
import SearchbarMenu from '../../../components/Searchbar/SearchbarMenu';
import IconTicketEmpty from '../../../assets/icons/IconTicketEmpty';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    TICKET_LIST_ALL_VIEW,
    TICKET_LIST_ALL_VIEW_ASSIGNEE
} from '../../../constants/menuPermissionConstant';
import LoadingLoader from '../../../components/LoadingLoader/LoadingLoader';

class TicketListAll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            ticketList: [],
            isSideOpen: false,
            page: 1,
            limit: 10,
            total: 0,
            orderBy: 'id',
            filter: {},
            isOrdered: false,
            selectedTicket: {},
            serverTime: '',
            searchBy: '',
            keyword: ''
        }
    }

    getDataTicketInitiate = () => {
        API_TICKET_LIST.getDataTicketInitiate(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        total: getContent(res).count_data,
                        serverTime: getServerTime(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getDataTicket = () => {
        let initiateOrderBy = this.state.orderBy === 'priority_level' || this.state.orderBy === 'updated_at' ? `${this.state.orderBy} desc` : this.state.orderBy;
        let orderBy = this.state.isOrdered ? initiateOrderBy : 'id desc';

        API_TICKET_LIST.getDataTicketAll(this.state.page, this.state.limit, orderBy, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        ticketList: getContent(res)
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getDataTicketInitiateLead = () => {
        API_TICKET_LIST.getDataTicketInitiateLead(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        total: getContent(res).count_data,
                        serverTime: getServerTime(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getDataTicketAllLead = () => {
        let initiateOrderBy = this.state.orderBy === 'priority_level' || this.state.orderBy === 'updated_at' ? `${this.state.orderBy} desc` : this.state.orderBy;
        let orderBy = this.state.isOrdered ? initiateOrderBy : 'id desc';

        API_TICKET_LIST.getDataTicketAllLead(this.state.page, this.state.limit, orderBy, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        ticketList: getContent(res)
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getDataTicketFilterAll = filter => {
        let filterArranged = ['is_closed eq false']
        if (filter.customerService !== '') {
            filterArranged.push(`assignee_id eq ${filter.customerService}`)
        }
        if (filter.priority !== '') {
            filterArranged.push(`priority_id eq ${filter.priority}`)
        }
        if (filter.status !== '') {
            filterArranged.push(`ticket.status eq ${filter.status}`)
        }
        let filterInitiate = `?start_date=${filter.startDate}&end_date=${filter.endDate}&filter=${filterArranged.join(', ')}`

        if (this.state.searchBy !== '' && this.state.keyword !== '') {
            API_SEARCH.getInitiateFilterSearchTicketAll(this.state.searchBy, this.state.keyword, filterInitiate, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            total: getContent(res).count_data,
                            serverTime: getServerTime(res)
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        } else {
            API_TICKET_LIST.getDataTicketAllLeadFilterInitiate(filterInitiate, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            total: getContent(res).count_data,
                            serverTime: getServerTime(res)
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        }

        let initiateOrderBy = this.state.orderBy === 'priority_level' || this.state.orderBy === 'updated_at' ? `${this.state.orderBy} desc` : this.state.orderBy;
        let orderBy = this.state.isOrdered ? initiateOrderBy : 'id desc';
        let filterData = `&start_date=${filter.startDate}&end_date=${filter.endDate}&filter=${filterArranged.join(', ')}`

        if (this.state.searchBy !== '' && this.state.keyword !== '') {
            API_SEARCH.getDataFilterSearchTicketAll(this.state.page, this.state.limit, this.state.searchBy, this.state.keyword, filterData, orderBy, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            ticketList: getContent(res)
                        });
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        } else {
            API_TICKET_LIST.getDataTicketAllLeadFilter(this.state.page, this.state.limit, filterData, orderBy, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            ticketList: getContent(res)
                        });
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        }
    }

    handleEnterSearch = (searchBy, keyword) => {
        this.handleSearch(searchBy, keyword, true);
    }

    handleSearch = async (searchBy, keyword, resetToFirstPage) => {
        if ((this.state.searchBy === '' && this.state.keyword === '') || resetToFirstPage) {
            await this.setState({ page: 1, searchBy, keyword, loading: true })
        } else {
            await this.setState({ searchBy, keyword, loading: true })
        }

        this.handleSetQueryParams();

        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
            API_SEARCH.getInitiateTicketAssigned(searchBy, keyword, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            total: getContent(res).count_data,
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))

            API_SEARCH.getDataTicketAssigned(this.state.page, this.state.limit, searchBy, keyword, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            ticketList: getContent(res)
                        });
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        } else {
            if (Object.keys(this.state.filter).length > 0) {
                let filter = this.state.filter;
                let filterArranged = ['is_closed eq false']
                if (filter.customerService !== '') {
                    filterArranged.push(`assignee_id eq ${filter.customerService}`)
                }
                if (filter.priority !== '') {
                    filterArranged.push(`priority_id eq ${filter.priority}`)
                }
                if (filter.status !== '') {
                    filterArranged.push(`ticket.status eq ${filter.status}`)
                }
                let filterInitiate = `?start_date=${filter.startDate}&end_date=${filter.endDate}&filter=${filterArranged.join(', ')}`

                API_SEARCH.getInitiateFilterSearchTicketAll(this.state.searchBy, this.state.keyword, filterInitiate, this.props.token)
                    .then(res => {
                        if (this._isMounted) {
                            this.setState({
                                total: getContent(res).count_data,
                                serverTime: getServerTime(res)
                            })
                        }
                    }).catch(errorHandler(this.props.handleLogout, this.props.history))

                let initiateOrderBy = this.state.orderBy === 'priority_level' || this.state.orderBy === 'updated_at' ? `${this.state.orderBy} desc` : this.state.orderBy;
                let orderBy = this.state.isOrdered ? initiateOrderBy : 'id desc';
                let filterData = `&start_date=${filter.startDate}&end_date=${filter.endDate}&filter=${filterArranged.join(', ')}`

                API_SEARCH.getDataFilterSearchTicketAll(this.state.page, this.state.limit, this.state.searchBy, this.state.keyword, filterData, orderBy, this.props.token)
                    .then(res => {
                        if (this._isMounted) {
                            this.setState({
                                loading: false,
                                ticketList: getContent(res)
                            });
                        }
                    }).catch(errorHandler(this.props.handleLogout, this.props.history))

                return
            }

            API_SEARCH.getInitiateTicketAll(searchBy, keyword, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            total: getContent(res).count_data,
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))

            API_SEARCH.getDataTicketAll(this.state.page, this.state.limit, searchBy, keyword, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            ticketList: getContent(res)
                        });
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        }
    }

    handleFilter = async filter => {
        let customerService = filter.customerService === '' ? this.state.filter.customerService : filter.customerService;
        let priority = filter.priority === '' ? this.state.filter.priority === 'all' ? '' : this.state.filter.priority : filter.priority === 'all' ? '' : filter.priority;
        let startDate = filter.startDate === '' ? this.state.filter.startDate : filter.startDate;
        let endDate = filter.endDate === '' ? this.state.filter.endDate : filter.endDate;
        let status = filter.status === '' ? this.state.filter.status : filter.status;

        await this.setState({
            loading: true,
            filter: {
                customerService,
                priority,
                startDate,
                endDate,
                status
            }
        });
        this.handleSetQueryParams();
        this.updateQueryParams(true);
    }

    handleResetFilter = async () => {
        await this.setState({
            loading: true,
            filter: {
                customerService: '',
                priority: '',
                startDate: '',
                endDate: '',
                status: ''
            }
        });
        this.handleSetQueryParams();
        this.updateQueryParams(true);
    }

    handleSelectTicket = data => {
        this.setState({
            isSideOpen: true,
            selectedTicket: data
        })
    }

    handleIsOrdered = async e => {
        await this.setState({
            isOrdered: e.target.checked,
            loading: true
        })

        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
            return this.getDataTicket();
        }

        if (Object.keys(this.state.filter).length > 0) {
            return this.getDataTicketFilterAll(this.state.filter);
        }

        this.getDataTicketAllLead();
    }

    handleChangeOrderBy = async data => {
        await this.setState({
            orderBy: data,
            isOrdered: true,
            loading: true
        })

        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
            return this.getDataTicket();
        }

        if (Object.keys(this.state.filter).length > 0) {
            return this.getDataTicketFilterAll(this.state.filter);
        }

        this.getDataTicketAllLead();
    }

    handlePreviousPage = async () => {
        if (this.state.page > 1) {
            await this.setState({
                page: this.state.page - 1,
                loading: true
            })

            this.handleSetQueryParams();
            this.updateQueryParams(false);
        }
    }

    handleNextPage = async () => {
        if (this.state.page * this.state.limit < this.state.total) {
            await this.setState({
                page: this.state.page + 1,
                loading: true
            })

            this.handleSetQueryParams();
            this.updateQueryParams(false);
        }
    }

    handleChangeLimit = async e => {
        await this.setState({
            limit: e.target.value,
            page: 1,
            loading: true
        })

        this.handleSetQueryParams();
        this.updateQueryParams(false);
    }

    handleSetQueryParams = () => {
        const params = new URLSearchParams();
        params.set('page', this.state.page);
        params.set('limit', this.state.limit);
        params.set('searchBy', this.state.searchBy);
        params.set('keyword', this.state.keyword);
        params.set('customerService', this.state.filter.customerService);
        params.set('priority', this.state.filter.priority);
        params.set('startDate', this.state.filter.startDate);
        params.set('endDate', this.state.filter.endDate);
        params.set('status', this.state.filter.status);

        const queryString = params.toString();
        const newLocation = { ...this.props.location, search: `?${queryString}` };
        this.props.history.push(newLocation);
    }

    updateQueryParams = async resetToFirstPage => {
        const params = new URLSearchParams(this.props.location.search);
        const page = params.get('page') || 1;
        const limit = params.get('limit') || 10;
        const searchBy = params.get('searchBy') || '';
        const keyword = params.get('keyword') || '';
        const customerService = params.get('customerService') || '';
        const priority = params.get('priority') || '';
        const startDate = params.get('startDate') || '';
        const endDate = params.get('endDate') || '';
        const status = params.get('status') || '';

        await this.setState({
            page: parseInt(page),
            limit: parseInt(limit),
            searchBy,
            keyword,
            filter: {
                customerService,
                priority,
                startDate,
                endDate,
                status
            }
        });

        if (searchBy !== '' && keyword !== '') {
            return this.handleSearch(searchBy, keyword, resetToFirstPage);
        }

        if (resetToFirstPage) {
            await this.setState({ page: 1 });
            this.handleSetQueryParams();
        }

        if (customerService !== '' || priority !== '' || startDate !== '' || endDate !== '' || status !== '') {
            return this.getDataTicketFilterAll(this.state.filter);
        }

        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
            this.getDataTicketInitiate();
            this.getDataTicket();
        } else {
            this.getDataTicketInitiateLead();
            this.getDataTicketAllLead();
        }
    }

    componentDidMount() {
        this._isMounted = true;

        this.updateQueryParams(false);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_VIEW, TICKET_LIST_ALL_VIEW_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                <SearchbarMenu handleSearch={this.handleEnterSearch} placeholder="Kata Kunci" />
                <LoadingLoader show={this.state.loading} />
                <div className="flex mb-5">
                    <div className={this.state.isSideOpen ? "w-9/12 mr-5" : "w-full flex justify-between"}>
                        <div>
                            <TicketChannel handleFilter={this.handleFilter} resetFilter={this.handleResetFilter} />
                        </div>
                        <div className={this.state.isSideOpen ? "hidden" : "flex items-center text-sm"}>
                            <TicketSort isOrdered={this.state.isOrdered} handleChangeOrderBy={this.handleChangeOrderBy} handleIsOrdered={this.handleIsOrdered} />
                            <ShowCountTicket limit={this.state.limit} handleChangeLimit={this.handleChangeLimit} />
                            <TicketPage page={this.state.page} limit={this.state.limit} total={this.state.total} />
                            <div id="btnpreviouspage" onClick={() => this.handlePreviousPage()}><PreviousPageButton /></div>
                            <div id="btnnextpage" onClick={() => this.handleNextPage()}><NextPageButton /></div>
                        </div>
                    </div>
                    <div className={this.state.isSideOpen ? "w-3/12" : "hidden"}>
                        <div id="btnhide" onClick={() => this.setState({ isSideOpen: false })}><HideButton /></div>
                    </div>
                </div>

                <div className="flex">
                    <div className={this.state.isSideOpen ? "w-9/12 mr-5 calculate-layout-ticket overflow-auto" : "w-full calculate-layout-ticket overflow-auto"}>
                        {
                            this.state.ticketList?.length === undefined || this.state.ticketList?.length === 0 ?
                                <div className="flex flex-col justify-center items-center h-full">
                                    <IconTicketEmpty />
                                    <p className="text-2xl text-darkblue opacity-30 mt-5">Tidak Ada Tiket</p>
                                </div>
                                :
                                <TicketCard ticketList={this.state.ticketList} openSide={this.handleSelectTicket} />
                        }
                    </div>
                    <div className={this.state.isSideOpen ? "w-3/12" : "hidden"}>
                        <TicketPhoneSideOutside data={this.state.selectedTicket} serverTime={this.state.serverTime} />
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketListAll);